/**
 * 영상분석 응답 보조 헬퍼.
 *
 * 데이터는 실제 백엔드 `GET /api/video-status/{lotId}` 에서 온다(hooks/useVideoStatus).
 * 영상분석 mismatch 는 "이력 적재"가 주 목적인 보조 신호라, lot 의 주 상태(브릿지 DB 헬스)를
 * 덮어쓰지 않는다. 어떤 lot 이 영상분석 대상인지는 BE 가 결정하고 (캐시에 lot 등장 여부)
 * `BridgeStatusDto.hasVideoAnalysis` 플래그로 알려준다 — FE 화이트리스트는 더 이상 없음.
 */

import type { VideoStatusResponse } from "../types/videoApi";

/**
 * 영상분석 응답에서 PROBLEM(불일치 임계 이상 지속) 인 구역 수. 응답 없으면 0.
 *
 * <p>lot 상태(브릿지 DB 헬스)를 바꾸지 않는다 — "영상 N구역 주의" 같은 약한 주황 경고에만 쓴다.
 * 즉 브릿지 데이터가 정상이면 lot 은 정상으로 두고, 영상 문제 구역만 가볍게 표시한다.</p>
 */
export function videoProblemCount(
  resp: VideoStatusResponse | null | undefined,
): number {
  if (!resp) return 0;
  return resp.zones.filter((z) => z.status === "PROBLEM").length;
}
